import React from "react";
import NcLink from "components/NcLink/NcLink";
import {signOut} from "firebase/auth";
import {auth} from "../../configs/firebase-config";
import {displayToast, toastType} from "../../global/Functions";
import {useHistory} from "react-router";

const DashboardRoot = () => {
  const history = useHistory();
  const username = auth.currentUser?.displayName;
  const signUserOut = () => {
    try{
      signOut(auth).then(() => {
        history.replace("/login");
      });
      displayToast("See you soon!", toastType.info);
    } catch (error) {
      displayToast("Something went wrong", toastType.error);
    }
  }
  return (
    <div className="rounded-xl min-h-full text-sm border border-neutral-100 dark:border-neutral-800 p-6 md:text-base">
      <span className="block text-lg mb-3">
        Welcome back <strong>{username}</strong>, not <strong>{username}</strong>?{" "}
        <NcLink to="#"><a onClick={signUserOut}>Sign Out</a></NcLink>
      </span>
      From your Personal Settings you can manage your
      {" "}
      <NcLink to="/dashboard/posts">Posts</NcLink>, <NcLink to="/dashboard/subscription">Subscription</NcLink>
      {" "}
      & edit your
      <NcLink to="/dashboard/edit-profile"> Profile</NcLink>.
      {" "}
    </div>
  );
};

export default DashboardRoot;
